import Button, { type ButtonProps } from "@mui/material/Button";
import { Link } from "react-router";

export const LinkButton = ({ children, ...rest }: ButtonProps<typeof Link, { component?: typeof Link }>) => {
  return (
    <Button component={Link} {...rest}>
      {children}
    </Button>
  );
};
